import { render, staticRenderFns } from "./hotel-name.vue?vue&type=template&id=a711fad6&"
import script from "./hotel-name.vue?vue&type=script&lang=ts&"
export * from "./hotel-name.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports